var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 661,
    viewBox: "0 0 1440 661",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3085_180421)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 660,
    transform: "translate(0 0.375)",
    fill: "#004469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1971.07 -596.659L1696.46 881.937L553.266 -95.1787L1971.07 -596.659Z",
    fill: "#033956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.84 -11.8506L-187.172 777.601L-230.853 -725.645L1092.84 -11.8506Z",
    fill: "#003552"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3085_180421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 660,
    fill: "white",
    transform: "translate(0 0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.1a9332187fce9437f8b9381c2127344f.svg";
export { ForwardRef as ReactComponent };